import {useEffect, useState} from 'react';
import {Dimension} from '../types';

function getWindowDimensions() {
	const {innerWidth: width, innerHeight: height} = window;
	return {
		width,
		height,
	};
}

export default function useWindowDimensions() {
	const [windowDimensions, setWindowDimensions] = useState<Dimension>(getWindowDimensions());
	const [isMobile, setMobile] = useState(false);

	useEffect(() => {
		function handleResize() {
			if (getWindowDimensions().width < 768) {
				setMobile(true);
			} else {
				setMobile(false);
			}
			setWindowDimensions(getWindowDimensions());
		}

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return {...windowDimensions, isMobile};
}
